<nb-card class="no-edge-card mb-0 modal-height-100-62" *ngIf="initialData">
	<div class="closeModal">
		<nb-icon class="m-1" icon="close-circle" [options]="{ animation: { type: 'zoom' } }" (click)="closeModal('')"
			nbTooltip="{{ 'SIGMACOMPONENT.CERRAR' | translate }}" nbTooltipPlacement="left">
		</nb-icon>
	</div>
	<nb-card-header class="border-bottom-0 background_themecolor">
		<div class="container">
			<div class="px-2 px-sm-5 py-2">
				<div class="d-flex justify-content-between gap-4 container-item-small">
					<!-- Inteligencia artificial -->
					<div class="item-style item-small" (click)="openAiUsageStats()"
						nbTooltip="Estadísticas de consumo de IA" nbTooltipPlacement="top">
						<span class="texto-pequeno">{{ "CENTROS.ARTIFICIALINTELLIGENCE" | translate }}</span>
						<div class="item-image-small">
							<img src="../../../../assets/images/control-panel/inteligencia artificial.png" width="70"
								alt='{{ "CENTROS.ARTIFICIALINTELLIGENCE" | translate }}'>
						</div>
					</div>
					<!-- Datos Globales -->
					<div class="item-style item-small" nbTooltip="{{ 'MENUACTIONS.DASHBOARDSUB1' | translate }}"
						nbTooltipPlacement="top" (click)="openTable()">
						<span class="texto-pequeno">{{ "MENUACTIONS.DASHBOARD1" | translate }}</span>
						<div class="item-image-small">
							<img src="../../../../assets/images/control-panel/global.png" width="50" />
						</div>
					</div>
					<!-- Datos Individuales -->
					<div class="item-style item-small" nbTooltip="{{ 'MENUACTIONS.DASHBOARDSUB2' | translate }}"
						nbTooltipPlacement="top" (click)="openTableIndividual()">
						<span class="texto-pequeno">{{ "MENUACTIONS.DASHBOARD2" | translate }}</span>
						<div class="item-image-small">
							<img src="../../../../assets/images/control-panel/pyme.png" width="50" />
						</div>
					</div>
					<!-- Estructura -->
					<div class="item-style item-small" (click)="openModalStructure()">
						<span class="texto-pequeno">Estructura</span>
						<div class="item-image-small">
							<img src="../../../../assets/images/control-panel/estructura-de-organizacion.png"
								width="50" />
						</div>
					</div>
					<!-- Tutorial -->
					<div class="item-style item-small" (click)="openModalTutorial()">
						<span class="texto-pequeno">{{ "COPILOTTUTORIAL.TUTORIAL" | translate }}</span>
						<div class="item-image-small">
							<img src="../../../../assets/images/control-panel/estructura-de-organizacion.png"
								width="50" />
						</div>
					</div>
					<!-- Contenido Denunciado (desactivado temporalmente) -->
					<div class="item-style item-small item-disabled" (click)="openModalDenuncias()"
						nbTooltip="{{ 'DENUNCIAR.DEACTIVATED' | translate }}" nbTooltipPlacement="top">
						<span class="texto-pequeno">{{ "MENUACTIONS.COMPLAINTS" | translate }}</span>
						<div class="item-image-small">
							<h2 class="m-0">⚠️</h2>
						</div>
					</div>
				</div>
			</div>
		</div>
	</nb-card-header>
	<nb-card-body class="px-0 px-sm-2">
		<div class="container">
			<div class="px-2 px-sm-5 h-325">
				<!-- ===============Fila superior================== -->
				<div class="d-flex justify-content-between flex-wrap gap-4 mt-2 h-30">
					<!-- ***Profesores*** -->
					<div class="item-style item-medium" (click)="verInforme(3, 3)">
						<!-- titulo e imagen -->
						<div class="d-flex flex-column" style="flex: 0 0 33%; max-width: 33%;">
							<p class="m-0">{{ "TASK.PROFESORES" | translate }}</p>
							<div class="item-image">
								<img src="../../../../assets/images/control-panel/profesor.png" width="70"
									alt='{{ "TASK.PROFESORES" | translate }}'>
							</div>
						</div>
						<!-- Datos -->
						<div class="d-flex flex-column style-registers">
							<div class="d-flex flex-column align-items-center">
								<h2>{{initialData.teachersRegistered}}</h2>
								<p class="title-card-registers">Registrados</p>
							</div>
							<div class="d-flex justify-content-center align-items-center gap-2">
								<div class="d-flex flex-column align-items-center gap-1">
									<h3>{{initialData.teachersRegisteredLastMonth}}</h3>
									<p>Nuevos en el último mes</p>
								</div>
								<div class="d-flex flex-column align-items-center gap-1">
									<h3>{{initialData.teachersOnlineLastWeek}}</h3>
									<p>Activos la última semana</p>
								</div>
							</div>
						</div>
					</div>
					<!-- ***Alumnos*** -->
					<div class="item-style item-medium" (click)="verInforme(2, 2)">
						<!-- titulo e imagen -->
						<div class="d-flex flex-column" style="flex: 0 0 33%; max-width: 33%;">
							<p class="m-0">{{ "GRUPOS.ALUMNOS" | translate }}</p>
							<div class="item-image">
								<img src="../../../../assets/images/control-panel/alumnos.png" width="70"
									alt='{{ "GRUPOS.ALUMNOS" | translate }}'>
							</div>
						</div>
						<!-- Datos -->
						<div class="d-flex flex-column style-registers">
							<div class="d-flex flex-column align-items-center">
								<h2>{{initialData.studentsRegistered}}</h2>
								<p class="title-card-registers">Registrados</p>
							</div>
							<div class="d-flex justify-content-center align-items-center gap-2">
								<div class="d-flex flex-column align-items-center gap-1">
									<h3>{{initialData.studentsRegisteredLastMonth}}</h3>
									<p>Nuevos en el último mes</p>
								</div>
								<div class="d-flex flex-column align-items-center gap-1">
									<h3>{{initialData.studentsOnlineLastWeek}}</h3>
									<p>Activos la última semana</p>
								</div>
							</div>
						</div>
					</div>
					<!-- ***Editores*** -->
					<div class="item-style item-medium" (click)="verInforme(1, 1)">
						<!-- Datos -->
						<div class="d-flex flex-column style-registers">
							<div class="d-flex flex-column align-items-center">
								<h2>{{initialData.editorsRegistered}}</h2>
								<p class="title-card-registers">Registrados</p>
							</div>
							<div class="d-flex justify-content-center align-items-center gap-2">
								<div class="d-flex flex-column align-items-center gap-1">
									<h3>{{initialData.editorsRegisteredLastMonth}}</h3>
									<p>Nuevos en el último mes</p>
								</div>
								<div class="d-flex flex-column align-items-center gap-1">
									<h3>{{initialData.editorsOnlineLastWeek}}</h3>
									<p>Activos la última semana</p>
								</div>
							</div>
						</div>
						<!-- texto e imagen -->
						<div class="d-flex flex-column" style="flex: 0 0 33%; max-width: 33%;">
							<p class="text-right m-0">{{ "EDITARCURSO.AUTORES" | translate }}</p>
							<div class="item-image">
								<img src="../../../../assets/images/control-panel/Niveles.png" width="70"
									alt='{{ "EDITARCURSO.AUTORES" | translate }}'>
							</div>
						</div>
					</div>
				</div>
				<!-- ===============Fila intermedia================== -->
				<div class="d-flex flex-wrap gap-4 mt-4 h-30">
					<!-- ***ASIGNATURAS*** -->
					<div class="item-style-large group-box group-box--card d-flex justify-content-center align-items-center">
						<div class="d-flex align-items-center justify-content-center gap-3 w-100">
							<div class="d-flex flex-column align-items-center text-center">
								<p class="m-0">{{ "CURSOS.SUBJECTS" | translate }}</p>
								<div class="item-image">
									<img src="../../../../assets/images/control-panel/tasks.png" width="70"
										alt='{{ "GRUPOS.TAREAS" | translate }}'>
								</div>
							</div>
							<div class="d-flex flex-column style-registers">
								<div class="d-flex flex-column align-items-center">
									<h2>{{initialData.subjectsTotal}}</h2>
									<p class="title-card-registers">Registradas</p>
								</div>
							</div>
						</div>
					</div>
					<!-- ***CENTROS*** -->
					<div class="item-style-large group-box group-box--card d-flex justify-content-center align-items-center">
						<div class="d-flex align-items-center justify-content-center gap-3 w-100">
							<div class="d-flex flex-column align-items-center text-center">
								<p class="m-0">{{ "USERDATA.CENTROS" | translate }}</p>
								<div class="item-image">
									<img src="../../../../assets/images/control-panel/indicadores sociales.png" width="70"
										alt='{{ "USERDATA.CENTROS" | translate }}'>
								</div>
							</div>
							<div class="d-flex flex-column style-registers">
								<div class="d-flex flex-column align-items-center">
									<h2>{{initialData.centersTotal}}</h2>
									<p class="title-card-registers">Registradas</p>
								</div>
							</div>
						</div>
					</div>
					<!-- ***Estudio Científico*** -->
					<div class="item-style-large group-box group-box--card d-flex justify-content-center align-items-center"
						(click)="openEstudioCientifico()">
						<div class="d-flex align-items-center justify-content-center gap-3 w-100">
							<div class="d-flex flex-column align-items-center text-center">
								<p class="m-0">Estudio Científico</p>
								<div class="item-image">
									<nb-icon icon="bar-chart-outline" style="font-size: 3rem; color: #3366ff;"></nb-icon>
								</div>
							</div>
							<div class="d-flex flex-column style-registers">
								<div class="d-flex flex-column align-items-center">
									<h2>{{initialData.estudioCientificoCentersTotal}}</h2>
									<p class="title-card-registers">Centros</p>
								</div>
							</div>
						</div>
					</div>
					<!-- ***Inventario Mandos*** -->
					<div class="item-style-large group-box group-box--card d-flex justify-content-center align-items-center"
						(click)="openInventarioMandos()">
						<div class="d-flex align-items-center justify-content-center gap-3 w-100">
							<div class="d-flex flex-column align-items-center text-center">
								<p class="m-0">Inventarios mandos</p>
								<div class="item-image">
									<nb-icon icon="keypad-outline" style="font-size: 3rem; color: #3366ff;"></nb-icon>
								</div>
							</div>
							<div class="d-flex flex-column style-registers">
								<div class="d-flex flex-column align-items-center">
									<h2>{{initialData.mandosTotal}}</h2>
									<p class="title-card-registers">Registrados</p>
								</div>
							</div>
						</div>
					</div>
				</div>
				<!-- ===============Fila inferior================== -->
				<div class="d-flex justify-content-between flex-wrap gap-4 mt-4 h-30">
					<!-- ***Grupos*** -->
					<div class="item-style item-medium" (click)="verInforme(0, 5)">
						<!-- texto e imagen -->
						<div class="d-flex flex-column" style="flex: 0 0 33%; max-width: 33%;">
							<p class="m-0">{{ "TASK.GROUPS" | translate }}</p>
							<div class="item-image">
								<img src="../../../../assets/images/control-panel/grupos.png" width="70"
									alt='{{ "TASK.GROUPS" | translate }}'>
							</div>
						</div>
						<!-- Datos -->
						<div class="d-flex flex-column style-registers">
							<div class="d-flex flex-column align-items-center">
								<h2>{{initialData.groupsTotal}}</h2>
								<p class="title-card-registers">Registrados</p>
							</div>
							<div class="d-flex justify-content-center align-items-center gap-2">
								<div class="d-flex flex-column align-items-center gap-1">
									<h3>{{initialData.groupsAverageStudentsPerGroup}}</h3>
									<p>Estudiantes en promedio</p>
								</div>
							</div>
						</div>
					</div>
					<!-- ***Cursos*** -->
					<div class="item-style item-medium">
						<!-- texto e imagen -->
						<div class="d-flex flex-column" style="flex: 0 0 33%; max-width: 33%;">
							<p class="m-0">{{ "EDITARCURSO.COURSES" | translate }}</p>
							<div class="item-image">
								<img src="../../../../assets/images/control-panel/Proyectos.png" width="70"
									alt='{{ "EDITARCURSO.COURSES" | translate }}'>
							</div>
						</div>
						<!-- Datos -->
						<div class="d-flex flex-column style-registers">
							<div class="d-flex flex-column align-items-center">
								<h2>{{initialData.projectsTotal}}</h2>
								<p class="title-card-registers">Creados</p>
							</div>
							<div class="d-flex justify-content-center align-items-center gap-2">
								<div class="d-flex flex-column align-items-center gap-1">
									<h3>{{initialData.projectsCreatedLastMonth}}</h3>
									<p>Nuevos en el último mes</p>
								</div>
								<div class="d-flex flex-column align-items-center gap-1">
									<h3>{{initialData.projectsUsedLastWeek}}</h3>
									<p>Revisados la última semana</p>
								</div>
							</div>
						</div>
					</div>
					<!-- ***Padres*** -->
					<div class="item-style item-medium">
						<!-- Datos -->
						<div class="d-flex flex-column style-registers">
							<div class="d-flex flex-column align-items-center">
								<h2>{{initialData.parentsRegistered}}</h2>
								<p class="title-card-registers">Registrados</p>
							</div>
							<div class="d-flex justify-content-center align-items-center gap-2">
								<div class="d-flex flex-column align-items-center gap-1">
									<h3>{{initialData.parentsRegisteredLastMonth}}</h3>
									<p>Nuevos en el último mes</p>
								</div>
								<div class="d-flex flex-column align-items-center gap-1">
									<h3>{{initialData.parentsOnlineLastWeek}}</h3>
									<p>Activos la última semana</p>
								</div>
							</div>
						</div>
						<!-- imagen -->
						<div class="d-flex flex-column" style="flex: 0 0 33%; max-width: 33%;">
							<p class="text-right m-0">{{ "USERDATA.PADRES" | translate }}</p>
							<div class="item-image">
								<img src="../../../../assets/images/control-panel/Padres.png" width="70"
									alt='{{ "USERDATA.PADRES" | translate }}'>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</nb-card-body>
</nb-card>